/* src/app/system-utils/json-viewer/json-viewer.component.scss */
.app-ace-editor {
  border: 2px solid #f8f9fa;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.toolbar {
  display: flex;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 10;
  flex-direction: row;
  gap: 10px;
}
:host {
  position: relative;
}
/*# sourceMappingURL=json-viewer.component.css.map */
